import React, { useState } from 'react';
import Spinner from "theme/Spinner";
import Text from "theme/Text";
import { StyleSheet, TouchableWithoutFeedback } from "react-native";
import _ from 'lodash';
import { useSelector } from "react-redux";
import { layoutStyles } from "styles/layout";
import Translate from "utils/translate";
import UserAvatar from "components/atoms/UserAvatar";
import { ThemedSizes, ThemedValues } from "styles/themed";
import { colorList } from "utils/colors";
import HelperArray from 'utils/helper-array'
import { employeeConstants } from 'utils/constants/employee-constants'
import i18n from 'utils/i18n'
import { dataConstants } from "services/redux/data/constants";
import ThemedItem from 'components/atoms/ThemedItem'
import DataItem from 'components/atoms/DataItem'
import HelperEmployeeFavourite from 'utils/HelperEmployeeFavourite'
import HelperSetting from 'utils/helper-setting'
import { settingsConstants } from 'utils/constants/settings-constants'
import { DataItemStyles } from 'styles/components/atoms/DataItem'
import { ThemedItemStyles } from 'styles/components/atoms/ThemedItem'
import { EmployeePresentStatus } from 'utils/constants/EmployeePresentStatus'
import HelperString from 'utils/helper-string'
import ThemedPressable from 'components/atoms/ThemedPressable'
import { constantsActive } from 'utils/constants/constants'
import ObjectBuilding from 'utils/objects/building'
import { bookingConstants } from 'utils/constants/booking-constants'
import { getScanningEnabled } from 'utils/objects/employee-scan'
import HelperTestID from 'utils/HelperTestID'
import { TESTID } from '_shared/config/testID'
import HelperEmployeePrivacy from 'utils/HelperEmployeePrivacy'
import * as Animatable from 'react-native-animatable'
import FetchCachedOtherEmployeeBookings from 'utils/fetch/cached/FetchCachedOtherEmployeeBookings'
import useEmployee from 'utils/hooks/use-employee'
import Icon from 'components/atoms/Icon'
import { IconSystemConstants, IconTimeslotConstants } from 'utils/constants/IconNameConstants'
import useEmployeeBookings from 'utils/hooks/use-employee-bookings'
import isEqual from 'react-fast-compare'
import { openUrl } from 'utils/helper-url'
import HelperDate, { dateFormat } from 'utils/helper-date'

export const EmployeeCardModes = {
	listItem: 'listItem',
	avatar: 'avatar'
};

const DataItemIconStyle = [ DataItemStyles.headerIcon ];

const EmployeeCard = ( {
	employee,

	style = {},
	mode = EmployeeCardModes.listItem,

	avatarSize = ThemedSizes.S,
	avatarHighlight = false,
	avatarShowIconEro = false,
	avatarShowIconConfidant = false,
	avatarLoading = false,
	avatarStyle = {},

	accessoryRight,
	actionItem,
	actionItemOnPress,

	show = EmployeeCardShowDefault,
	showHeart = true,
	onPress,
	selectedLocationDate = null,

	navigation = null,

	animationOnMount = false,
	children }
) => {
	const _employee  = useSelector( state => {
		return state.data[dataConstants.EMPLOYEE];
	} );
	const _departments = useSelector( state => {
		return state.data[dataConstants.DEPARTMENTS];
	} );
	const _jobtitles = useSelector( state => {
		return state.data[dataConstants.JOBTITLES];
	} );
	const _teams = useSelector( state => {
		return state.data[dataConstants.TEAMS];
	} );
	const _timeslotKinds = useSelector(state => {
		return state.data[dataConstants.TIMESLOT_KINDS];
	} );

	const isFavourite = useSelector( state => {
		return _.get( state.data[ dataConstants.FAVOURITES ], [ employee?.guid, 'is_favourite' ], 'no' ) !== 'no';
	});

	let loading = true;
	let fetchedEmployee = null;
	let fetchedStatus = null;
	let fetchedLocation = null;
	
	selectedLocationDate = selectedLocationDate === null ? HelperDate.date() : selectedLocationDate

	const [ processingFavourite, setProcessingFavourite ] = useState( false );
	
	const _employeeBasic = useEmployee( employee?.guid );
	const _employeeBookings = useEmployeeBookings( employee?.guid, selectedLocationDate?.format( dateFormat.DATE ) );
	
	const { isScanningEnabled } = getScanningEnabled()

	const selectedLocationDateIsToday = selectedLocationDate === null | HelperDate.fn.isToday( selectedLocationDate );

	if( employee.guid !== _employee.guid ){
		if( _employeeBasic !== undefined ) {
			fetchedEmployee = _employeeBasic;
		} else {
			fetchedEmployee = employee;
		}
	} else {
		fetchedEmployee = _employee;
	}

	// Check the employee
	if( fetchedEmployee !== null ) {
		loading = false;
	}

	if( _employeeBookings !== null ){
		fetchedLocation = _employeeBookings.location;
		fetchedStatus = _employeeBookings.status;
	}

	const onEmployeePress = () => {
		if( _.isFunction( onPress ) ){
			onPress( fetchedEmployee );
		}
	}

	const onActionItemPress = () => {
		if( _.isFunction( actionItemOnPress ) ){
			actionItemOnPress( fetchedEmployee );
		}
	}

	const sendEmail = ( email ) => {
		return openUrl( `mailto:${ email }` );
	}

	const callPhone = ( phonenumber ) => {
		return openUrl( `tel:${ phonenumber }` );
	}

	const renderDataItemIcon = ( dataItemKey ) => {

		switch( dataItemKey ) {
			case EmployeeCardShowConstants.EMAILADDRESS:
				return <Icon icon={ IconSystemConstants.ENVELOPE } style={ DataItemIconStyle } />;

			case EmployeeCardShowConstants.MOBILE_PHONENUMBER:
				return <Icon icon={ IconSystemConstants.MOBILE_PHONE } style={ DataItemIconStyle } />;

			case EmployeeCardShowConstants.LANDLINE_PHONENUMBER:
				return <Icon icon={ IconSystemConstants.PHONE } style={ DataItemIconStyle } />;

			case EmployeeCardShowConstants.LOCATION_TODAY:
				return <Icon icon={ IconSystemConstants.BUILDING } style={ DataItemIconStyle } />;

			case EmployeeCardShowConstants.DEPARTMENT:
			case EmployeeCardShowConstants.JOBTITLE:
			case EmployeeCardShowConstants.TEAM:
			case EmployeeCardShowConstants.COMPANY:
			case EmployeeCardShowConstants.TIMESLOT_KIND:
				return null;
		}
	}

	const renderDataItem = ( dataItemKey ) => {
		let dataTitle = null;
		let dataContent = null;
		let dataIcon = renderDataItemIcon( dataItemKey );

		const titleStyle = [];

		let forceVisibility = false;

		// Set to - instead of NULL to always this value if it's set to ALWAYS
		if( _.get( show, dataItemKey, EmployeeCardShowValues.NO ) === EmployeeCardShowValues.ALWAYS || _.get( show, dataItemKey, EmployeeCardShowValues.NO ) === EmployeeCardShowValues.FORCE ){
			dataContent = '-';
			forceVisibility = true;
		}

		switch( dataItemKey ){
			case EmployeeCardShowConstants.DEPARTMENT:
			case EmployeeCardShowConstants.JOBTITLE:
			case EmployeeCardShowConstants.TEAM:
				let path = null;
				let pool = null;

				switch( dataItemKey ) {
					case EmployeeCardShowConstants.DEPARTMENT:
						dataTitle = i18n.t( 'department' );
						path = [ 'department' ];
						pool = _departments;
						break;

					case EmployeeCardShowConstants.JOBTITLE:
						dataTitle = i18n.t( 'jobtitle' );
						path = [ 'jobtitle' ];
						pool = _jobtitles;
						break;

					case EmployeeCardShowConstants.TEAM:
						dataTitle = i18n.t( 'team' );
						path = [ 'team' ];
						pool = _teams;
						break;
				}

				// First look for the whole field
				let poolResult = _.get( fetchedEmployee, path, {} );
				if( !_.isEmpty( poolResult ) ) {

					// Try to translate
					dataContent = Translate.field( poolResult , 'title' );

					// When no translation we try to check in the state
					if( dataContent === null ) {
						const guid = _.get( poolResult, [ 'guid' ], null );

						if( guid !== null ) {
							poolResult = _.get( pool, guid, null );

							if( poolResult !== null ) {
								dataContent = Translate.field( poolResult , 'title' );
							}
						}
					}
				}
				break;

			case EmployeeCardShowConstants.EMAILADDRESS:
				let email = _.get( fetchedEmployee, 'email', false );

				if( HelperSetting.isYes( settingsConstants.COWORKER_SHOW_EMAILADDRESS ) && !HelperString.isEmptyString( email ) ) {
					dataTitle = i18n.t( 'email' );
					dataContent = (
						<Text
							style={styles.clickable}
							selectable
							onPress={ sendEmail.bind( this, email ) }>

							{ email }
						</Text>
					);
				}
				break;

			case EmployeeCardShowConstants.MOBILE_PHONENUMBER:
				if( _.get( show, dataItemKey, EmployeeCardShowValues.NO ) !== EmployeeCardShowValues.FORCE ) {
					if( !HelperEmployeePrivacy.canShowPhoneNumber( fetchedEmployee, isFavourite ) ) {
						return null;
					}
				}

				const phonenumber = _.get( fetchedEmployee, 'phonenumber', false );
				if( HelperString.isEmptyString( phonenumber ) ) {
					return null;
				}

				dataTitle = i18n.t( 'phonenumber' );
				dataContent = (
					<Text
						style={ styles.clickable }
						selectable
						onPress={ callPhone.bind( this, phonenumber ) }>

						{ phonenumber }
					</Text>
				);
				break;

			case EmployeeCardShowConstants.LANDLINE_PHONENUMBER:
				if( _.get( show, dataItemKey, EmployeeCardShowValues.NO ) !== EmployeeCardShowValues.FORCE ) { // phone number can be forced on for instance ERO
					if ( HelperSetting.isNo( settingsConstants.COWORKER_SHOW_LANDLINE_PHONENUMBER ) ) {
						return null;
					}
				}

				const landlinePhoneNumber = _.get( fetchedEmployee, [ 'landline_phonenumber' ], null );
				if( HelperString.isEmptyString( landlinePhoneNumber ) ){
					return null;
				}

				dataTitle = i18n.t( 'phonenumber' );
				dataContent = (
					<Text
						style={ styles.clickable }
						selectable
						onPress={ callPhone.bind( this, landlinePhoneNumber ) }>

						{ landlinePhoneNumber }
					</Text>
				);
				break;

			case EmployeeCardShowConstants.LOCATION_TODAY:
				let locationToday = fetchedLocation

				// Special ERO/Confidant
				if( _.get( _employeeBasic, 'response_employee', constantsActive.NO ) === constantsActive.YES || _.get( _employeeBasic, 'confidant', constantsActive.NO ) === constantsActive.YES  ) {
					if( fetchedLocation === null ) {
						const bookingsToday = _.filter( _.get( _employeeBasic, 'bookings' ), booking => {
							return HelperDate.fn.isToday( HelperDate.date( booking.booking_date, dateFormat.DATE ) )
						})

						if( _.size( bookingsToday ) > 0 ) {
							_.forEach( bookingsToday, booking => {
								locationToday = FetchCachedOtherEmployeeBookings.createLocationName( booking );
								return false;
							});

							if( locationToday === null ) {
								locationToday = i18n.t( 'constants.not_in_office' );
							}
						}
					}
				}

				if( locationToday !== null ) {
					dataTitle = i18n.t( 'location' );
					dataContent = locationToday;
				}
				break;

			case EmployeeCardShowConstants.LICENSE_PLATE:
				const licensePlates = [];
				_.forEach( employee?.bookings, booking => {
					if( booking.kind === bookingConstants.TRANSPORT && !HelperString.isEmptyString( booking.license_plate ) ) {
						if( !_.includes( licensePlates, booking.license_plate ) ) {
							licensePlates.push( booking.license_plate )
						}
					}
				})

				if( _.size( licensePlates ) > 0 ) {
					dataTitle = i18n.t( 'constants.license_plate' );
					dataContent = HelperArray.naturalJoin( licensePlates );
				}
				break;

			case EmployeeCardShowConstants.STATUS_TODAY:
				dataTitle = null;
				dataContent = null;

				forceVisibility = true;

				let statusToday = fetchedStatus

				// Special ERO/Confidant
				if( _.get( _employeeBasic, 'response_employee', constantsActive.NO ) === constantsActive.YES || _.get( _employeeBasic, 'confidant', constantsActive.NO ) === constantsActive.YES ) {
					if( fetchedLocation === null && selectedLocationDateIsToday ) {
						const buildings = _.isEmpty( _employeeBasic ) ? [] : ObjectBuilding.getAllFromEmployee( _employeeBasic );

						_.forEach( buildings, building => {
							statusToday = building.present ? EmployeePresentStatus.PRESENT : EmployeePresentStatus.NOT_YET_PRESENT
						});
					}
				}

				// Check if this status is allowed
				let statusAllowed = true;
				if( !isScanningEnabled ) {
					const scanningDisabledStatusList = [ EmployeePresentStatus.HAVING_LUNCH, EmployeePresentStatus.IN_MEETING ]
					if( HelperSetting.isYes( settingsConstants.WORKDAY_EDITING ) ) {
						scanningDisabledStatusList.push( EmployeePresentStatus.WORK_FROM_HOME )
					}

					statusAllowed = _.includes( scanningDisabledStatusList, statusToday );
				}

				if( statusToday !== null && statusAllowed ) {
					dataTitle = i18n.t( `enums.employee_status.${statusToday}` );
					dataContent = null;
					titleStyle.push( DataItemStyles.textStrong );

					switch( statusToday ) {
						case EmployeePresentStatus.UNKNOWN:
							dataIcon =  <Icon icon={ IconSystemConstants.STATUS } style={ DataItemIconStyle } />;
							titleStyle.push( DataItemStyles.textGrey );
							break;

						case EmployeePresentStatus.HAVING_LUNCH:
							dataIcon = <Icon icon={ IconTimeslotConstants.LUNCH } style={ DataItemIconStyle } />;
							titleStyle.push( DataItemStyles.textBlue );
							break;

						case EmployeePresentStatus.IN_MEETING:
							dataIcon = <Icon icon={ IconTimeslotConstants.MEETING_ROOM } style={ DataItemIconStyle } />;
							titleStyle.push( DataItemStyles.textRed );
							break;

						case EmployeePresentStatus.NOT_YET_PRESENT:
							dataIcon = <Icon icon={ IconSystemConstants.STATUS } style={ DataItemIconStyle } />;
							break;

						case EmployeePresentStatus.WORK_FROM_HOME:
							dataIcon = <Icon icon={ IconSystemConstants.STATUS } checked={ true } style={ [ DataItemIconStyle, DataItemStyles.headerIconGreen ] } />;
							titleStyle.push( DataItemStyles.textGreen );
							break;

						case EmployeePresentStatus.WORK_FROM_HOME_2:
							dataIcon = <Icon icon={ IconSystemConstants.STATUS } checked={ false } style={ DataItemIconStyle } />;
							titleStyle.push( DataItemStyles.textGrey );
							break;

						case EmployeePresentStatus.PRESENT:
							dataIcon = <Icon icon={ IconSystemConstants.STATUS } checked={ true } style={ [ DataItemIconStyle, DataItemStyles.headerIconGreen ] } />;
							titleStyle.push( DataItemStyles.textGreen );
							break;

						case EmployeePresentStatus.LEFT:
							dataIcon = <Icon icon={ IconSystemConstants.STATUS } style={ DataItemIconStyle } />;
							titleStyle.push( DataItemStyles.textRed );
							break;
					}
				}else if(  _.get( show, dataItemKey, EmployeeCardShowValues.NO ) === EmployeeCardShowValues.IF_IS_NOT_EMPTY ){
					forceVisibility = false;
				}
				break;

			case EmployeeCardShowConstants.TIMESLOT_KIND:
				const timeslotKindNames = _.map( _.get( employee, 'bookings', [] ), booking => {
					return _.get( booking, ['timeslot', 'timeslot_kind', 'name'], null );
				})

				if( !_.isEmpty( timeslotKindNames ) ) {
					dataTitle = i18n.t( 'management:form.kind.title' );
					dataContent = HelperArray.naturalJoin( timeslotKindNames )
				}
				break;
		}

		if( ( dataTitle !== null && dataContent !== null ) || forceVisibility ) {
			return (
				<DataItem
					key={ HelperString.hash( dataItemKey ) }
					identifier={ dataItemKey }
					icon={ dataIcon }
					titleStyle={ titleStyle }
					content={ dataContent }>

					{ dataTitle }
				</DataItem>
			);
		}

		return null;
	}

	const renderListItem = () => {
		let name = fetchedEmployee.guid === _employee.guid ? i18n.t('basic.you') : fetchedEmployee.name;
		if( name === null || HelperString.isEmptyString( name ) ) {
			name = fetchedEmployee?.email ?? '?'
		}

		let dataItems = [];
		if( _.isFunction( show ) ){
			dataItems = show( fetchedEmployee );
		} else {

			_.forEach( show, ( showValue, showItem ) => {
				// Check if we can show for work from home
				if( fetchedStatus === EmployeePresentStatus.WORK_FROM_HOME || EmployeePresentStatus.WORK_FROM_HOME_2 ) {
					if( [ EmployeeCardShowConstants.LOCATION_TODAY ].includes( showItem ) ) {
						return true;
					}
				}

				if( _.get( show, showItem, EmployeeCardShowValues.NO ) !== EmployeeCardShowValues.NO ) {
					const returnedDataItem = renderDataItem( showItem );

					if ( returnedDataItem !== null ) {
						dataItems.push( returnedDataItem );
					}
				}
			})
		}

		const employeeKind = _.get( fetchedEmployee, 'kind', employeeConstants.KIND_INTERNAL );
		if( employeeKind === employeeConstants.KIND_EXTERNAL ) {
			dataItems.push(
				<DataItem
					key={ HelperString.hash('external') }
					identifier={ 'external' }>

					{ i18n.t('management:generic.employee.kind.external') }
				</DataItem>
			);
		}

		const accessoryLeft = (
			<UserAvatar
				employee={ fetchedEmployee }
				size={ avatarSize }
				highlight={ avatarHighlight }
				showIconEro={ avatarShowIconEro }
				showIconConfidant={ avatarShowIconConfidant }
				style={ [ avatarStyle ] }
				loading={ loading || avatarLoading }
				navigation={ navigation }
			/>
		);

		const testID = fetchedEmployee.guid !== _employee.guid ? HelperTestID.generate( TESTID.HOME.EMPLOYEE_CARD.EMPLOYEE_CARD, fetchedEmployee.guid ) : TESTID.HOME.EMPLOYEE_CARD.EMPLOYEE_CARD_LOGGED_IN
		if( !loading && _.isEmpty( actionItem ) && showHeart ){

			if( HelperEmployeePrivacy.canFavourite( fetchedEmployee, isFavourite ) || isFavourite ) {
				actionItem = (
					<ThemedPressable onPress={ toggleFavourite } hitSlop={ 10 } testID={ HelperTestID.generate( testID, TESTID.HOME.EMPLOYEE_CARD.HEART )}>
						<Icon icon={ IconSystemConstants.FAVOURITE } checked={ isFavourite } style={ [ ThemedItemStyles.actionItemIcon ] } />
					</ThemedPressable>
				);

				if( processingFavourite ) {
					actionItem = <Spinner size="small" />
				}
			}
		} else if( _.isFunction( actionItemOnPress ) ) {
			actionItem = (
				<ThemedPressable
					onPress={ onActionItemPress }>

					{ actionItem }
				</ThemedPressable>
			)
		}

		const themedItem = (
			<ThemedItem
				key={ HelperString.hash( 'employee-card-item', fetchedEmployee ) }
				identifier={ HelperString.hash( 'employee-card-item-id', fetchedEmployee ) }
				accessoryLeft={ accessoryLeft }
				accessoryLeftSize={ [ ThemedSizes.XXS, ThemedSizes.XS, ThemedSizes.S ].includes( avatarSize ) ? 45 : 60 }
				accessoryLeftHeightSizing={ 'minHeight' }
				accessoryRight={ accessoryRight }
				title={ name }
				items={ dataItems }
				actionItem={ actionItem }
				testID={ testID }>

				{ children }
			</ThemedItem>
		);

		if( _.isFunction( onPress ) ){
			return (
				<ThemedPressable
					style={ styles.pressable }
					onPress={ onEmployeePress }>

					{ themedItem }
				</ThemedPressable>
			)
		}

		return themedItem;
	}

	const doneProcessingFavourite = () => {
		setProcessingFavourite( false )
	}

	const toggleFavourite = () => {
		HelperEmployeeFavourite.setFavourite( fetchedEmployee.guid, !isFavourite, setProcessingFavourite.bind( this, true ), doneProcessingFavourite, doneProcessingFavourite );
	}

	const renderAvatar = () => {
		return (
			<TouchableWithoutFeedback
				onPress={ onPress }>

				<UserAvatar
					employee={ fetchedEmployee }
					size={ avatarSize }
					highlight={ avatarHighlight }
					style={ avatarStyle }
					loading={ loading || avatarLoading }
					showIconEro={ avatarShowIconEro }
					showIconConfidant={ avatarShowIconConfidant }>

					{ children }
				</UserAvatar>
			</TouchableWithoutFeedback>
		);
	}

	switch( mode ) {
		case EmployeeCardModes.listItem:

			if( animationOnMount !== false ){
				if( animationOnMount === true ){
					animationOnMount = 'bounceIn';
				}
				return (
					<Animatable.View animation={ animationOnMount } key={ fetchedEmployee.guid }>
						{ renderListItem() }
					</Animatable.View>
				);
			}

			return renderListItem();

		case EmployeeCardModes.avatar:
			return renderAvatar();
	}
}

export const EmployeeCardShowConstants = {
	ERO: 'ero',
	COMPANY: 'company',
	TEAM: 'teams',
	DEPARTMENT: 'department',
	JOBTITLE: 'jobtitle',
	MOBILE_PHONENUMBER: 'mobile_phonenumber',
	LANDLINE_PHONENUMBER: 'landline_phonenumber',
	EMAILADDRESS: 'emailaddress',
	STATUS_TODAY: 'status_today',
	LOCATION_TODAY: 'location_today',
	LICENSE_PLATE: 'license_plate',
	TIMESLOT_KIND: 'timeslot_kind'
}
export const EmployeeCardShowValues = {
	YES: 'yes',
	NO: 'no',
	ALWAYS: 'always',
	FORCE: 'force',
	IF_IS_NOT_EMPTY: 'if_is_not_empty'
};

export const EmployeeCardShowDefault = {
	[ EmployeeCardShowConstants.COMPANY ]: EmployeeCardShowValues.YES,
	[ EmployeeCardShowConstants.TEAM ]: EmployeeCardShowValues.YES,
	[ EmployeeCardShowConstants.DEPARTMENT ]: EmployeeCardShowValues.YES,
	[ EmployeeCardShowConstants.JOBTITLE ]: EmployeeCardShowValues.YES,
	[ EmployeeCardShowConstants.MOBILE_PHONENUMBER ]: EmployeeCardShowValues.NO,
	[ EmployeeCardShowConstants.LANDLINE_PHONENUMBER ]: EmployeeCardShowValues.NO,
	[ EmployeeCardShowConstants.LOCATION_TODAY ]: EmployeeCardShowValues.NO,
	[ EmployeeCardShowConstants.STATUS_TODAY ]: EmployeeCardShowValues.NO,
};

export const EmployeeCardShowBasic = {
	[ EmployeeCardShowConstants.COMPANY ]: EmployeeCardShowValues.NO,
	[ EmployeeCardShowConstants.TEAM ]: EmployeeCardShowValues.NO,
	[ EmployeeCardShowConstants.DEPARTMENT ]: EmployeeCardShowValues.NO,
	[ EmployeeCardShowConstants.JOBTITLE ]: EmployeeCardShowValues.NO,
	[ EmployeeCardShowConstants.MOBILE_PHONENUMBER ]: EmployeeCardShowValues.NO,
	[ EmployeeCardShowConstants.LANDLINE_PHONENUMBER ]: EmployeeCardShowValues.NO,
	[ EmployeeCardShowConstants.LOCATION_TODAY ]: EmployeeCardShowValues.NO,
	[ EmployeeCardShowConstants.STATUS_TODAY ]: EmployeeCardShowValues.NO,
};

export const EmployeeCardShowAll = {
	[ EmployeeCardShowConstants.COMPANY ]: EmployeeCardShowValues.YES,
	[ EmployeeCardShowConstants.TEAM ]: EmployeeCardShowValues.ALWAYS,
	[ EmployeeCardShowConstants.DEPARTMENT ]: EmployeeCardShowValues.YES,
	[ EmployeeCardShowConstants.JOBTITLE ]: EmployeeCardShowValues.YES,
	[ EmployeeCardShowConstants.MOBILE_PHONENUMBER ]: EmployeeCardShowValues.YES,
	[ EmployeeCardShowConstants.LANDLINE_PHONENUMBER ]: EmployeeCardShowValues.YES,
	[ EmployeeCardShowConstants.EMAILADDRESS ]: EmployeeCardShowValues.YES,
	[ EmployeeCardShowConstants.LOCATION_TODAY ]: EmployeeCardShowValues.YES,
	[ EmployeeCardShowConstants.STATUS_TODAY ]: EmployeeCardShowValues.YES,
};

export const EmployeeCardShowERO = {
	[ EmployeeCardShowConstants.STATUS_TODAY ]: EmployeeCardShowValues.ALWAYS,
	[ EmployeeCardShowConstants.LOCATION_TODAY ]: EmployeeCardShowValues.ALWAYS,
	[ EmployeeCardShowConstants.MOBILE_PHONENUMBER ]: EmployeeCardShowValues.FORCE,
	[ EmployeeCardShowConstants.LANDLINE_PHONENUMBER ]: EmployeeCardShowValues.FORCE,
};

export const EmployeeCardShowConfidant = {
	[ EmployeeCardShowConstants.STATUS_TODAY ]: EmployeeCardShowValues.ALWAYS,
	[ EmployeeCardShowConstants.LOCATION_TODAY ]: EmployeeCardShowValues.ALWAYS,
	[ EmployeeCardShowConstants.MOBILE_PHONENUMBER ]: EmployeeCardShowValues.FORCE,
	[ EmployeeCardShowConstants.LANDLINE_PHONENUMBER ]: EmployeeCardShowValues.FORCE,
};

const styles = StyleSheet.create({
	header: {
		flex: 1,
		alignSelf: 'flex-start',
		alignItems: 'center',
		flexDirection: 'row',
		marginHorizontal: -ThemedValues.marginHorizontal,
		paddingHorizontal: ThemedValues.marginHorizontal,
		backgroundColor: 'transparent',
		...layoutStyles.headerStyles,
	},

	avatarContainer: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'flex-start',
		width: 'auto'
	},

	profileDetailsContainer: {
		flex: 1,
		marginHorizontal: 8,
		flexDirection: 'column',
	},

	favouriteIconContainer: {
		marginHorizontal: 8,
	},

	favouriteIcon: {
		color: colorList.PRIMARY.primary
	},

	backdrop: {
		backgroundColor: 'rgba(0, 0, 0, 0.5)',
	},

	accessoryRightContainer: {
		flex: 0,
		marginHorizontal: 8,
		flexDirection: 'column',
	},

	clickable: {
		fontSize: 14,
		textDecorationLine: 'underline',
		color: colorList.BLUE.primary
	},

	pressable: {
		flex: 1,
		minHeight: 'auto'
	}
});

export default React.memo( EmployeeCard, isEqual );
